export default {
  resiliations_pending: false,
  resiliations: []
}
